// import React, { useEffect, useState } from "react";
// import "./TvBrochurePopup.css";
// import tvBrochure from "../components/images/TV BROCHURE 2026.pdf";

// const TvBrochurePopup = () => {
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setOpen(true);
//     }, 500); // slight delay for smooth UX

//     return () => clearTimeout(timer);
//   }, []);

//   const handleDownload = () => {
//     const link = document.createElement("a");
//     link.href = tvBrochure;
//     link.download = "Redwolf-TV-Brochure-2026.pdf";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     setOpen(false);
//   };

//   if (!open) return null;

//   return (
//     <section className="tv-brochure-overlay">
//       <div className="tv-brochure-modal">
//         <button
//           className="tv-close-btn"
//           onClick={() => setOpen(false)}
//         >
//           ✕
//         </button>

//         <div className="tv-icon">📺</div>

//         <h2>
//           Download <span>TV Brochure 2026</span>
//         </h2>

//         <p>
//           Explore the complete range of <strong>Redwolf Smart TVs</strong>.
//           Get specifications, features, sizes, and warranty details
//           in one official brochure.
//         </p>

//         <div className="tv-actions">
//           <button className="tv-download-btn" onClick={handleDownload}>
//             Download PDF
//           </button>

//           <button
//             className="tv-cancel-btn"
//             onClick={() => setOpen(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TvBrochurePopup;


import React, { useEffect, useState } from "react";
import "./BrochurePopup.css";

const BrochurePopup = ({
  brochure,
  title = "Download Brochure",
  subtitle = "Explore full specifications, features & warranty details.",
  icon = "📄",
  fileName = "Redwolf-Brochure.pdf",
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 600); // smooth entry delay

    return () => clearTimeout(timer);
  }, []);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="brochure-overlay">
      <div className="brochure-modal">
        <button className="close-btn" onClick={() => setOpen(false)}>
          ✕
        </button>

        <div className="brochure-icon">{icon}</div>

        <h2>
          {title.split(" ")[0]} <span>{title.split(" ").slice(1).join(" ")}</span>
        </h2>

        <p>{subtitle}</p>

        <div className="brochure-actions">
          <button className="download-btn" onClick={handleDownload}>
            Download PDF
          </button>
          <button className="cancel-btn" onClick={() => setOpen(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrochurePopup;
